import React from 'react';
import { NeuroMessage } from '@ignitesales/neuro-application';
import shared_messages_en from '../../../../../../_themes/first-commonwealth-theme/src/shared/js/i18n/en/messages_en.mjs';
import consumer_messages_en from '../../../../../../_themes/first-commonwealth-theme/src/shared/js/i18n/en/consumer_messages_en.mjs';
import messages_en from '../en/messages_en.mjs';

const messages = {
  ...shared_messages_en,
  ...consumer_messages_en,
  ...messages_en
};

const goalTypesBuilderKey = 'goalTypes';
const editCardRender = <i className="fa fa-pencil"/>;
const removeCardRender = <i className="fa fa-trash-o"/>;
const saveCardRender = <NeuroMessage id={`${goalTypesBuilderKey}.cardBuilder.save`} />;

const renderCardLayout = (builderKey, cardKey) => {
  const iconClass = messages[`${builderKey}.${cardKey}.iconClass`];
  const title = messages[`${builderKey}.${cardKey}.title`];
  const header = <><i className={iconClass}/><div>{title}</div></>;
  return { 
    [`${builderKey}.${cardKey}`]: header,
    [`${cardKey}.cardBuilder.title`]: header,
  };
};

export default {    
    ...renderCardLayout(goalTypesBuilderKey, 'emergencyGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'futureGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'childGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'vacationGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'holidayGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'educationGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'healthcareGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'majorPurchaseGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'lifeEventGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'debtConsolidationGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'establishRebuildCreditGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'homeGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'homeImprovementGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'refinanceHomeGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'vehicleGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'retirementGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'insuranceGoal'),
    ...renderCardLayout(goalTypesBuilderKey, 'creditCardGoal'),
    [`${goalTypesBuilderKey}.cardBuilder.editCard`]: editCardRender,
    [`${goalTypesBuilderKey}.cardBuilder.removeCard`]: removeCardRender,
    [`${goalTypesBuilderKey}.cardBuilder.saveCard`]: saveCardRender,
};
